import { AxiosError, AxiosResponse } from "axios";
import Core from "../core";

async function getEmpDependents(employee_id: number, full_path: string) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/employee/dependents?emp_id=${employee_id}&full_path=true&locale=${localStorage.getItem(
      "emplang"
    )}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function addDependentDocs(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(`/v1/employee/addDependentDocs`, payload);

  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
function deleteDocs(id: number, empId: number) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .delete(`/v1/employee/deleteDependentDocs?id=${id}&emp_id=${empId}`)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function deleteInsuranceDocs(id: number, empId: number) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .delete(`/v1/employee/dependent/insuranceDocs?id=${id}&emp_id=${empId}`)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
async function getInsuranceAttachedDoc(id: number, full_path: string) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/employee/dependent/insuranceDocDownload/${id}?full_path=true`
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function updateDepDocs(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(`/v1/employee/updateDependentDocs`, payload);

  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getAttachedDoc(id: number, full_path: string) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/employee/dependentDocDownload/${id}?full_path=true`
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function editInsurance(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(
    `/v1/employee/dependent/updateInsuranceDocs`,
    payload
  );

  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function addInsurance(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(
    `/v1/employee/dependent/addInsuranceDocs`,
    payload
  );

  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
function updateProfilePic(payload: any) {
  const api = Core.getInstance().apiforImageUp();

  return new Promise((resolve, reject) => {
    api
      .post(`/v1/employee/dependent/profilePicUpdate`, payload)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export const dependentsServices = {
  getEmpDependents,

  addDependentDocs,
  deleteDocs,
  getAttachedDoc,
  updateDepDocs,

  addInsurance,
  editInsurance,
  getInsuranceAttachedDoc,
  deleteInsuranceDocs,

  updateProfilePic,
};
